import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { CompanyType } from 'proposals/components/SelectCompany'
import { usePublicRequestForProposalParticipate } from './queries/useRequestForProposalMutations'
import PublicRequestForProposalParticipateSuccess from './PublicRequestForProposalParticipateSuccess'
import PublicRequestForProposalParticipate from './PublicRequestForProposalParticipate'
import { useSnackbar } from 'snackbar/SnackbarContext'

const ParticipateContainer = styled(Box)(({ theme: { spacing, shape, breakpoints } }) => ({
  width: '100%',
  borderRadius: shape.borderRadius,
  backgroundColor: '#EFEFEF',
  padding: spacing(2),
  [breakpoints.up('md')]: {
    maxWidth: 443
  }
}))

type PublicRequestForProposalParticipateContainerProps = {
  uniqueToken: string
}

const PublicRequestForProposalParticipateContainer: React.FC<PublicRequestForProposalParticipateContainerProps> = ({ uniqueToken }) => {
  const { t } = useTranslation()
  const [company, setCompany] = React.useState<CompanyType | null>(null)
  const [email, setEmail] = React.useState('')
  const [emailError, setEmailError] = React.useState('')
  const [isSubmitted, setIsSubmitted] = React.useState(false)
  
  const { showSnackbar } = useSnackbar()
  
  const participateMutation = usePublicRequestForProposalParticipate()

  const validateEmail = (email: string): string => {
    if (!email) {
      return t('email-is-required')
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      return t('invalid-email')
    }
    return ''
  }

  const handleEmailBlur = () => {
    const error = validateEmail(email)
    setEmailError(error)
  }

  const handleParticipate = async () => {
    if (!company || !email || emailError) return

    participateMutation.mutate(
      {
        uniqueToken,
        payload: {
          email,
          businessId: company.businessId,
          companyName: company.name
        }
      },
      {
        onSuccess: () => setIsSubmitted(true),
        onError: (error) => {
          console.error('Failed to participate:', error)
          showSnackbar(t('failed-to-participate'), 'error')
        }
      }
    )
  }

  return (
    <ParticipateContainer displayPrint="none">
      {isSubmitted ? (
        <PublicRequestForProposalParticipateSuccess />
      ) : (
        <PublicRequestForProposalParticipate 
          email={email} 
          company={company} 
          setCompany={setCompany} 
          onEmailChange={setEmail}
          onSubmit={handleParticipate}
          emailError={emailError}
          onEmailBlur={handleEmailBlur}
          isLoading={participateMutation.isPending}
        />
      )}
    </ParticipateContainer>
  )
}

export default PublicRequestForProposalParticipateContainer